var _path, _path2, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M7.517,1.728.318,13.74a.508.508,0,0,0,0,.479.564.564,0,0,0,.453.24h14.4a.527.527,0,0,0,.453-.24.444.444,0,0,0,0-.479L8.45,1.728a.542.542,0,0,0-.48-.264A.5.5,0,0,0,7.517,1.728Z",
    fill: "#eb780a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M14.862,14.782H1.137a1.155,1.155,0,0,1-.977-.5.936.936,0,0,1-.02-1.016h0L7,1.716a1.175,1.175,0,0,1,1.006-.534,1.157,1.157,0,0,1,1,.547l6.866,11.547a.934.934,0,0,1-.032,1.01A1.157,1.157,0,0,1,14.862,14.782ZM1.451,13.771l13.059.013A.193.193,0,0,0,14.7,13.5L8.208,2.513a.224.224,0,0,0-.375,0L1.265,13.486A.193.193,0,0,0,1.451,13.771Z",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect829",
    x: 7.5,
    y: 4.5,
    width: 1,
    height: 6,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "path831",
    cx: 8,
    cy: 12.25,
    r: 0.75,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningStatus);
export default __webpack_public_path__ + "static/media/warningStatus.981673cc167bc15e60038ce8344a7d5c.svg";
export { ForwardRef as ReactComponent };